<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Status</th>
        <th>{{'image' | translate}}</th>
        <th>{{'brand' | translate}}</th>
        <th>{{'item' | translate}}</th>
        <th><i class="fa fa-zalando mr-5"></i>Zalando</th>
        <th><i class="fa fa-amazon mr-5"></i>Amazon</th>
        <th><i class="fa fa-ebay mr-5"></i>eBay</th>
        <th><i class="fa fa-spartoo mr-5"></i>Spartoo</th>
        <th><i class="fa fa-check24 mr-5"></i>Check24</th>
        <th><i class="fa fa-check24 mr-5"></i>Goertz</th>
        <th class="text-right">{{'edit' | translate}}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="product, index in products">
        <td class="text-center">
          <span :class="['label', product.is_active ? 'label-success' : 'label-danger']">{{product.is_active ? 'is_active' : 'inactive' | translate | toLower}}</span>
        </td>
        <td><img class="img-preview" :src="product.image"/></td>
        <td>{{product.brand}}</td>
        <td>WWS-Nr: {{product.wws_number}}<br/><small class="text-muted">WWS-ID: {{product.wws_model}}</small><br/><small class="text-muted">{{'image' | translate}} ID: {{product.img_id}}</small></td>
        <td>
          <div class="btn-group" data-toggle="btn-toggle">
            <button type="button" @click="activate(product.wws_model, [{name: 'zalando', active: true}])" :class="[product.channels.find(a => {return a.name === 'zalando'}).active ? 'active' : '', 'btn', 'btn-xs btn-success']"><i class="fa fa-check"></i></button>
            <button type="button" @click="activate(product.wws_model, [{name: 'zalando', active: false}])" :class="[product.channels.find(a => {return a.name === 'zalando'}).active? '' : 'active', 'btn', 'btn-xs btn-danger']"><i class="fa fa-ban"></i></button>
          </div>
        </td>
        <td>
          <div class="btn-group" data-toggle="btn-toggle">
            <button type="button" @click="activate(product.wws_model, [{name: 'amazon', active: true}])"  :class="[product.channels.find(a => {return a.name === 'amazon'}).active ? 'active' : '', 'btn', 'btn-xs btn-success']"><i class="fa fa-check"></i></button>
            <button type="button" @click="activate(product.wws_model, [{name: 'amazon', active: false}])" :class="[product.channels.find(a => {return a.name === 'amazon'}).active? '' : 'active', 'btn', 'btn-xs btn-danger']"><i class="fa fa-ban"></i></button>
          </div>
        </td>
        <td>
          <div class="btn-group" data-toggle="btn-toggle">
            <button type="button" @click="activate(product.wws_model, [{name: 'ebay', active: true}])"  :class="[product.channels.find(a => {return a.name === 'ebay'}).active ? 'active' : '', 'btn', 'btn-xs btn-success']"><i class="fa fa-check"></i></button>
            <button type="button" @click="activate(product.wws_model, [{name: 'ebay', active: false}])" :class="[product.channels.find(a => {return a.name === 'ebay'}).active? '' : 'active', 'btn', 'btn-xs btn-danger']"><i class="fa fa-ban"></i></button>
          </div>
        </td>
        <td>
          <div class="btn-group" data-toggle="btn-toggle">
            <button type="button" @click="activate(product.wws_model, [{name: 'spartoo', active: true}])"  :class="[product.channels.find(a => {return a.name === 'spartoo'}).active ? 'active' : '', 'btn', 'btn-xs btn-success']"><i class="fa fa-check"></i></button>
            <button type="button" @click="activate(product.wws_model, [{name: 'spartoo', active: false}])" :class="[product.channels.find(a => {return a.name === 'spartoo'}).active? '' : 'active', 'btn', 'btn-xs btn-danger']"><i class="fa fa-ban"></i></button>
          </div>
        </td>
        <td>
          <div class="btn-group" data-toggle="btn-toggle">
            <button type="button" @click="activate(product.wws_model, [{name: 'mirapodo', active: true}])"  :class="[product.channels.find(a => {return a.name === 'mirapodo'}).active ? 'active' : '', 'btn', 'btn-xs btn-success']"><i class="fa fa-check"></i></button>
            <button type="button" @click="activate(product.wws_model, [{name: 'mirapodo', active: false}])" :class="[product.channels.find(a => {return a.name === 'mirapodo'}).active? '' : 'active', 'btn', 'btn-xs btn-danger']"><i class="fa fa-ban"></i></button>
          </div>
        </td>
        <td>
          <div class="btn-group" data-toggle="btn-toggle">
            <button type="button" @click="activate(product.wws_model, [{name: 'tamaris', active: true}])"  :class="[product.channels.find(a => {return a.name === 'tamaris'}).active ? 'active' : '', 'btn', 'btn-xs btn-success']"><i class="fa fa-check"></i></button>
            <button type="button" @click="activate(product.wws_model, [{name: 'tamaris', active: false}])" :class="[product.channels.find(a => {return a.name === 'tamaris'}).active? '' : 'active', 'btn', 'btn-xs btn-danger']"><i class="fa fa-ban"></i></button>
          </div>
        </td>
        <td>
          <div class="btn-group" data-toggle="btn-toggle">
            <button type="button" @click="activate(product.wws_model, [{name: 'check24', active: true}])"  :class="[product.channels.find(a => {return a.name === 'check24'}).active ? 'active' : '', 'btn', 'btn-xs btn-success']"><i class="fa fa-check"></i></button>
            <button type="button" @click="activate(product.wws_model, [{name: 'check24', active: false}])" :class="[product.channels.find(a => {return a.name === 'check24'}).active? '' : 'active', 'btn', 'btn-xs btn-danger']"><i class="fa fa-ban"></i></button>
          </div>
        </td>
        <td>
          <div class="btn-group" data-toggle="btn-toggle">
            <button type="button" @click="activate(product.wws_model, [{name: 'goertz', active: true}])"  :class="[product.channels.find(a => {return a.name === 'goertz'}).active ? 'active' : '', 'btn', 'btn-xs btn-success']"><i class="fa fa-check"></i></button>
            <button type="button" @click="activate(product.wws_model, [{name: 'goertz', active: false}])" :class="[product.channels.find(a => {return a.name === 'goertz'}).active? '' : 'active', 'btn', 'btn-xs btn-danger']"><i class="fa fa-ban"></i></button>
          </div>
        </td>
        <td>
          <div class="btn-group" data-toggle="btn-toggle">
            <button type="button" @click="activate(product.wws_model, [{name: 'marco_tozzi', active: true}])"  :class="[product.channels.find(a => {return a.name === 'marco_tozzi'}).active ? 'active' : '', 'btn', 'btn-xs btn-success']"><i class="fa fa-check"></i></button>
            <button type="button" @click="activate(product.wws_model, [{name: 'marco_tozzi', active: false}])" :class="[product.channels.find(a => {return a.name === 'marco_tozzi'}).active? '' : 'active', 'btn', 'btn-xs btn-danger']"><i class="fa fa-ban"></i></button>
          </div>
        </td>
        <td>
          <div class="btn-group" data-toggle="btn-toggle">
            <button type="button" @click="activate(product.wws_model, [{name: 'caprice', active: true}])"  :class="[product.channels.find(a => {return a.name === 'caprice'}).active ? 'active' : '', 'btn', 'btn-xs btn-success']"><i class="fa fa-check"></i></button>
            <button type="button" @click="activate(product.wws_model, [{name: 'caprice', active: false}])" :class="[product.channels.find(a => {return a.name === 'caprice'}).active? '' : 'active', 'btn', 'btn-xs btn-danger']"><i class="fa fa-ban"></i></button>
          </div>
        </td>
        <td class="text-right">
          <router-link :to="'/productmanagement/'+ product.wws_model"><b-btn class="btn btn-info btn-app"><i class="fa fa-edit"></i>{{'edit' | translate($parent.$parent.language)}}</b-btn></router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ['products'],
  data () {
    return {
      sortClass: window.localStorage.getItem('sortType') ? window.localStorage.getItem('sortType') === 'asc' : false
    }
  },
  methods: {
    sort () {
      this.sortClass = !this.sortClass
      this.$emit('sort', this.sortClass ? 'asc' : 'desc')
    },
    activate (id, channels) {
      API.put(`inventory/${id}`, {channels: channels})
        .then(res => {
          this.products.find(p => { return p.wws_model === id }).channels.find(a => { return a.name === channels[0].name }).active = channels[0].active
          this.$emit('alert', {type: 'success', dismiss: 4, message: 'Success!'})
        })
        .catch(error => {
          this.$emit('alert', {type: 'danger', dismiss: 4, message: ['Error!']})
        })
    }
  },
  watch: {
    products () {}
  }
}
</script>
<style>
  .sortable:hover {
    cursor: pointer;
  }
</style>
<style scoped>
  .alert.alert-message {
    position: fixed;
  }
  .alert-dismissible {
    z-index: 9999;
    position: fixed;
    width: 300px;
    top: 60px;
    right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/Tables/ProductsTable.vue